import React from 'react';
import BasicButton from '../Button/BasicButton';

const StarbeatProductCard = ({ item, onClick }) => {
  return (
    <div className='starbeat-product-card'>
      <div className='starbeat-product-card-quantity-group'>
        <div className='starbeat-product-icon-group'>
          <i className='icon icon-star-point' />
        </div>
        <span className='starbeat-product-quantity-info'>{item.name}</span>
      </div>
      <div className='starbeat-product-card-price-group'>
        <BasicButton
          buttonTxt={`${item.price?.toLocaleString()} ${item.currency}`}
          buttonType={'primary'}
          buttonSize={'sm-plus'}
          onClick={onClick}
        />
      </div>
    </div>
  );
};

export default StarbeatProductCard;
